//* ------------------------------------*\
//    $ARIA STRINGS
//* ------------------------------------*/

const ARIA = {
  EXPANDED: 'aria-expanded',
  FALSE: false,
  HIDDEN: 'aria-hidden',
  SELECTED: 'aria-selected',
  TRUE: true
};

export default ARIA;
